import { render, staticRenderFns } from "./approvedDetailedReportBody.vue?vue&type=template&id=d6c0297e&scoped=true"
import script from "./approvedDetailedReportBody.vue?vue&type=script&lang=js"
export * from "./approvedDetailedReportBody.vue?vue&type=script&lang=js"
import style0 from "./approvedDetailedReportBody.vue?vue&type=style&index=0&id=d6c0297e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c0297e",
  null
  
)

export default component.exports